import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SingleRequestRow } from "../../components/List/SingleRequestRow";
import TherapyRequestService from "../../services/TherapyRequest";
export const TherapyRequestList = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState("");
  const [list, setList] = useState<any>();

  const fetchData = async () => {
    TherapyRequestService.getRequest(filter)
      .then((res: any) => {
        setList(res.data);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Manoshala Care - Free Therapy Request</div>
      <div className="p-4">
        <div className="top_section_container">
          <div className="col-sm-3 expert_container_item expert_list_button ">
            <div className="input-group">
              <select
                className="form-control filter-sec"
                id="lead_status"
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                }}
              >
                <option value="">Select Status</option>
                <option value="APPROVED">Approved</option>
                <option value="PENDING">Pending</option>
              </select>

              <div className="input-group-append">
                <button
                  className="btn action-btn"
                  type="button"
                  onClick={() => {
                    fetchData();
                  }}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Main section */}
        <div className="main-section" style={{ overflowX: "auto" }}>
          <table className="table">
            <thead>
              <tr>
                {/* <th>User Id</th> */}
                <th>User Information</th>
                <th>Age</th>
                <th>City</th>
                <th>Budget</th>
                <th>Profession</th>
                <th>Symptoms</th>
                <th>Language</th>
                <th>Booking Using Request Code</th>
                <th>Total Bookings</th>
                <th>Status</th>
                <th>Coupon</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {list && list.length > 0 ? (
                list.map((el: any) => (
                  <SingleRequestRow key={el._id} props={el} />
                ))
              ) : (
                <h1 className="no-data">No Data Found</h1>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
